var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      attrs: {
                        "align-v": "end",
                        offset: "0",
                        "offset-lg": "6",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            "apeironGwApp.temasSnp.acciones.buscar"
                          ),
                        },
                        on: {
                          keyup: function ($event) {
                            return _vm.buscarEnTemas()
                          },
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                          },
                        },
                        model: {
                          value: _vm.filtroTemas,
                          callback: function ($$v) {
                            _vm.filtroTemas = $$v
                          },
                          expression: "filtroTemas",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-2" },
                [
                  _c(
                    "b-col",
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          bordered: "",
                          small: "",
                          "thead-class": "custom-header",
                          items: _vm.temasFiltrados,
                          fields: _vm.fieldsTemas,
                          "show-empty": "",
                          "empty-text": _vm.$t(
                            "apeironGwApp.temasSnp.mensajes.sinRegistros"
                          ),
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(principal)",
                            fn: function (data) {
                              return [
                                _c("span", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: data.item.principal,
                                      expression: "data.item.principal",
                                    },
                                  ],
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.temasSnp.form.esPrincipal"
                                      )
                                    ),
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "cell(acciones)",
                            fn: function (data) {
                              return [
                                _vm.esEscritura
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover.top",
                                            value: _vm.$t(
                                              "apeironGwApp.temasSnp.acciones.hacerPrincipal"
                                            ),
                                            expression:
                                              "$t('apeironGwApp.temasSnp.acciones.hacerPrincipal')",
                                            modifiers: {
                                              hover: true,
                                              top: true,
                                            },
                                          },
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: data.item?.activo,
                                            expression: "data.item?.activo",
                                          },
                                        ],
                                        attrs: {
                                          size: "sm",
                                          variant: "outline",
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "check-circle",
                                            variant: "primary",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.esEscritura
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover.top",
                                            value: _vm.$t(
                                              "apeironGwApp.temasSnp.acciones.editar"
                                            ),
                                            expression:
                                              "$t('apeironGwApp.temasSnp.acciones.editar')",
                                            modifiers: {
                                              hover: true,
                                              top: true,
                                            },
                                          },
                                        ],
                                        attrs: {
                                          size: "sm",
                                          variant: "outline",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editarTema(data.item)
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "pencil",
                                            variant: "primary",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.esEscritura
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover.top",
                                            value: _vm.$t(
                                              "apeironGwApp.temasSnp.acciones.eliminar"
                                            ),
                                            expression:
                                              "$t('apeironGwApp.temasSnp.acciones.eliminar')",
                                            modifiers: {
                                              hover: true,
                                              top: true,
                                            },
                                          },
                                        ],
                                        attrs: {
                                          size: "sm",
                                          variant: "outline",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.mostrarModalEliminarTema(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "trash",
                                            variant: "primary",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("b-pagination", {
                        attrs: {
                          "total-rows": _vm.registros,
                          "per-page": _vm.perPage,
                          "aria-controls": "my-table",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.esEscritura
                ? _c(
                    "b-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "9" } },
                        [
                          _c(
                            "b-alert",
                            { attrs: { show: "", variant: "info" } },
                            [
                              _c("ul", [
                                _c("li", [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.temasSnp.mensajes.guardarSeccion",
                                          {
                                            guardarSeccion: _vm
                                              .$t(
                                                "apeironGwApp.temasSnp.acciones.guardarSeccion"
                                              )
                                              .toString(),
                                          }
                                        )
                                      ),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.temasSnp.mensajes.seleccionarUnPrincipal"
                                        )
                                      ),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.temasSnp.mensajes.registrosMaximos",
                                          { maximos: _vm.registrosMaximos }
                                        )
                                      ),
                                    },
                                  }),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "mt-4",
                          staticStyle: { "text-align": "end" },
                          attrs: { cols: "3" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                block: "",
                                variant: "primary",
                                disabled: !_vm.esEscritura,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.guardarTemas()
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.temasSnp.acciones.guardarSeccion"
                                    )
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                staticClass: "mr-2",
                                attrs: { icon: "save" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-modal",
                        {
                          attrs: { id: "modal-eliminar", size: "md" },
                          scopedSlots: _vm._u([
                            {
                              key: "modal-title",
                              fn: function () {
                                return [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.temasSnp.mensajes.tituloEliminar"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "modal-footer",
                              fn: function () {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mt-3",
                                      attrs: {
                                        variant: "primary",
                                        disabled: !_vm.esEscritura,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.eliminarTema()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.temasSnp.acciones.eliminar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mt-3",
                                      attrs: { variant: "secondary" },
                                      on: {
                                        click: function ($event) {
                                          _vm.mostrarModalEliminar = false
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.temasSnp.acciones.cerrar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.mostrarModalEliminar,
                            callback: function ($$v) {
                              _vm.mostrarModalEliminar = $$v
                            },
                            expression: "mostrarModalEliminar",
                          },
                        },
                        [
                          _vm._v(" "),
                          _c("div", { staticClass: "d-block text-center" }, [
                            _c("h3", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "apeironGwApp.temasSnp.mensajes.detalleEliminar"
                                  )
                                ),
                              },
                            }),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }